@import 'core';

/**
 * @prop --ads-cta-link-color: Link text color
 * @prop --ads-cta-link-color-hover: Link text color on hover
 *
 * @prop --ads-cta-link-icon-color: Icon color
 * @prop --ads-cta-link-icon-margin-left: Icon left margin value
 * @prop --ads-cta-link-icon-margin-right: Icon right margin value
 * @prop --ads-cta-link-icon-rotation: Icon rotation value
 */

::slotted(*) {
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
}

:host {
  display: inline-block;
}

:host([theme='default']) {
  @include ads-vars-component-cta-link-default;
}

:host([theme='dark']) {
  @include ads-vars-component-cta-link-dark;
}

:host([dir='ltr']) {
  @include ads-vars-component-cta-link-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-cta-link-rtl;
}

.c-cta-link {
  @include ads-cta-link;
}
